const countryRules = {
  "+91": { length: 10 }, // India
  "+971": { length: 9 }, // UAE
  "+966": { length: 9 }, // Saudi Arabia
  "+968": { length: 8 }, // Oman
  "+973": { length: 8 }, // Bahrain
  "+20": { length: 10 }, // Egypt
  "+962": { length: 9 }, // Jordan
  "+90": { minLength: 7, maxLength: 11 }, // Turkey
  "+7": { minLength: 9, maxLength: 11 }, // Kazakhstan
  "+48": { length: 9 }, // Poland
  "+86": { minLength: 11, maxLength: 11 }, // China
  "+965": { minLength: 8, maxLength: 9 }, // Kuwait
  "+967": { minLength: 8, maxLength: 9 }, // Yemen
};
export const validateMobileNumber = (countryCode, value,t) => {
  const rules = countryRules[countryCode];

  if (!countryCode) {
    return Promise.reject(new Error(t("SELECT_COUNTRY_CODE_ERR_MSG")));
  }
  if (!rules) {
    if (value && (value.length < 7 || value.length > 12)) {
      return Promise.reject(
        new Error(t("MOBILE_NO_DEFAULT_MIN_MAX_MSG"))
      );
    } else {
      return Promise.resolve();
    }
  }
  if (
    value &&
    (value.length < rules.length ||
      value.length > rules.length ||
      value.length < rules.minLength ||
      value.length > rules.maxLength)
  ) {
    return Promise.reject(
      new Error(
        `${t("MOBILE_VAL_PART_ONE")} ${
          rules.minLength
            ? `${t("MOBILE_VAL_PART_TWO")} ${rules.minLength} ${t("MOBILE_VAL_PART_THREE")} ${rules.maxLength} ${t("MOBILE_VAL_PART_FOUR")}`
            : `${rules.length} ${t("MOBILE_VAL_PART_FOUR")}`
        }`
      )
    );
  }
  return Promise.resolve();
};

export const getMinAndMaxLengthForMobileNumber = (countryCode) => {
  let defaultMinAndMaxLength = { minLength: 7, maxLength: 11 };
  if (countryCode) {
    let rules = countryRules[countryCode];
    if (rules) {
      if(rules.length){
        return {minLength:rules.length,maxLength:rules.length}
      }
      return rules;
    }
  }

  return defaultMinAndMaxLength;
};

export const generateCountryCodeLabel = (name, phone_code,icon_path,showIcon) => (<><div className="hide-selected" style={{display:"flex",justifyContent:"flex-start"}}>{showIcon&&<span><img src={icon_path} alt={name} height="20px" width="20px" style={{verticalAlign:"sub",marginRight:"3px"}}/></span>}<span>{name} ({phone_code}) </span></div><div className="hide-in-option" style={{display:"flex",justifyContent:"flex-start"}}>{phone_code}</div></>)

//const generateCountryCodeLabel = (name, phone_code,icon_path) => (<><div style={{display:"flex",justifyContent:"flex-start"}}><span><img src={icon_path} alt={name} height="20px" width="20px" style={{verticalAlign:"sub",marginRight:"3px"}}/></span><span>{name} ({phone_code}) </span></div></>);
export   const getMobileCountryCodeList = (mobileCountryCodeList,isDisplayFlag)=>
    mobileCountryCodeList?.map(item => ({
     ...item,
     key:`${item.name.toLowerCase()} ${item.phone_code}`,
     label: generateCountryCodeLabel(item.name, item.phone_code,item.icon_path,isDisplayFlag), // Create label field
     value: item.phone_code, // Map phone_code to value
     searchKey: `${item.name.toLowerCase()} ${item.phone_code} ${item.iso3.toLowerCase()}`, // Combined search key
   }));
